import { auth } from '../sk/auth/index';
import { users } from '../sk/users/index';
import { administration } from '../sk/administration/index';
import { tests } from '../sk/tests/index';
import { dashboard } from '../sk/dashboard';
import { homes } from '../sk/homes/index';
import { training } from '../sk/training/index';
import { reports } from '../sk/reports/index';

// Messages for SK language
const strings = {
    appName: 'Watt Analytics',
    loading: 'Načítavam....',
    language: {
        sk: 'Slovenčina',
        en: 'English',
        de: 'Deutch',
        zh: '中文'
    },
    ok: 'OK',
    select: 'Zvoliť',
    edit: 'Upraviť',
    save: 'Uložiť',
    download: 'Nahrať',
    close: 'Zavrieť',
    cancel: 'Zrušiť',
    version: 'Verzia',
    invite: 'Pozvať',
    adminAddUser: 'Pridať užívateľa',
    reload: 'Obnoviť',
    delete: 'Vymazať',
    undelete: 'Obnoviť',
    dashboardRoute: 'Nástenka',
    noDataAvailable: 'Žiadne dáta',
    sureToUndeleteTitle: 'Naozaj chcete obnoviť tento záznam?',
    sureToDeleteTitle: 'Naozaj chcete vymazať tento záznam?',
    add: 'Pridať',
    permissionsIsAdminTag: 'Administrátor',
    permissionsIsNotAdminTag: 'Užívateľ',
    permissionsIsTesterTag: 'Tester',
    permissionsIsInstallerTag: 'Installer',
    maxLengthReached: 'Presiahli ste maximálnu dĺžku',
    actionsLabel: 'Akcie',
    logoutLink: 'Odhlásiť sa',
    requiredField: 'Toto pole je povinné',
    emailFormatField: 'Emailová adresa nemá požadovaný formát.',
    msgErrorApi: 'Chyba pri volaní požiadavky zo servera',
    perMinute: 'za min.',
    id: 'ID',
    auth,
    administration,
    tests,
    users,
    homes,
    dashboard,
    training,
    reports
};

export default strings;
